import { ApiState } from '../../utils/requestAction';
import requestReducer from '../requestReducer';


export interface ProductSectionUpsertState extends ApiState {
  productSectionId?: string
}

export default requestReducer<ProductSectionUpsertState>('PRODUCTSECTION_UPSERT')
